export default function RouteLoadingFallback() {
  return (
    <div
      role="status"
      aria-label="Ładowanie"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '50dvh',
      }}
    >
      <div
        style={{
          width: 32,
          height: 32,
          border: '3px solid rgba(2, 122, 242, 0.2)',
          borderTopColor: '#027af2',
          borderRadius: '50%',
          animation: 'route-loading-spin 0.8s linear infinite',
        }}
      />
    </div>
  );
}
